import React, { useContext } from "react";
import "./User_Info.css";
import { Context } from "../../../utils/context";

const User_Info = () => {
  const { user } = useContext(Context);

  console.log(user, "user");

  return (
    <section className="User_Info">
      <div className="left_div">
        <p className="gray_text">Welcome</p>
        <p className="blue_text">{user?.name}</p>
        <p className="gray_text">
          Your Current Balance is{" "}
          <span className="dar_blue_text">{user?.Wallet?.amount}</span>
        </p>
      </div>
    </section>
  );
};

export default User_Info;
